import React, { SyntheticEvent, useState } from 'react';
import { Box, Card, CardActions, CardMedia, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PhotoUploadWidget from '../../app/common/imageUpload/PhotoUploadWidget';
import { useStore } from '../../app/stores/store';
import UserPng from '../../assets/user.png';
import { withNavbar } from '../../app/layout/HOC';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';

// C:\Users\rsb\source\repos\Partners\Partner-UI\src\assets\timages\user.png
const btn = {
   color: '#234f1e',
    '&:hover': {
        color: '#234f1e',
        opacity: [0.9, 0.8, 0.7],
    },
}

function ProfilePhoto() {
    const { playerProfileStore: { uploadPhoto, uploadingPhoto,
        deletePhoto, }, userStore: { user, isLoggedIn } } = useStore();
    const [addPhotoMode, setAddPhotoMode] = useState(false);

    function handlePhotoUpload(file: Blob) {
        uploadPhoto(file).then(() => setAddPhotoMode(false));
    }

    function handleDeletePhoto(e: SyntheticEvent<HTMLButtonElement>) {
        deletePhoto().then(() => setAddPhotoMode(false));
    }

    return (
        <Box sx={{ flexGrow: 0, mt: 15, textAlign: 'center', ml: 'auto', mr: 'auto', maxWidth: 1000 }}>
            {user &&
                <Grid direction="column" alignItems="center" justifyContent="center" >
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" color="textSecondary" >{!user.image && <> You don't have any photo </>} </Typography>

                        {addPhotoMode ? (
                            <PhotoUploadWidget uploadPhoto={handlePhotoUpload} loading={uploadingPhoto} />
                        ) : (
                            <Box component='div' sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Card sx={{ width: 200, height: 280 }}>
                                    <CardMedia
                                        sx={{ width: '100%', height: 200 }}
                                        image={user.image || UserPng}
                                        title="User Photo"
                                    />
                                    <CardActions disableSpacing>
                                        {isLoggedIn && (

                                            <Tooltip title={addPhotoMode ? "Cancel" : !user.image ? "Add" : "Edit"} onClick={() => setAddPhotoMode(!addPhotoMode)}
                                            sx={btn} >
                                                <IconButton disabled={uploadingPhoto}>
                                                    {addPhotoMode ? <CancelIcon sx={btn} /> : !user.image ? <AddIcon sx={btn} /> : <EditIcon sx={btn} />}
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {user.image && !addPhotoMode &&

                                            <Tooltip title="Delete" sx={btn} onClick={(e: any) => handleDeletePhoto(e)}>
                                                <IconButton>
                                                    {!uploadingPhoto ? <><DeleteIcon sx={btn} /></> : <CircularProgress size='1.4rem' sx={btn} />}
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </CardActions>
                                </Card>
                            </Box>
                        )}
                    </Grid>
                </Grid>}
        </Box >
    )
}
const ProfilePhotoPage = withNavbar(observer(ProfilePhoto));
export default ProfilePhotoPage;